import { createTriggerStore } from "@utils/createTriggerStore";
import { SessionWizardTriggerPayload } from "./types";

const store = createTriggerStore<SessionWizardTriggerPayload>();

export const openSessionWizardModal = store.open;
export const closeSessionWizardModal = store.close;
export const useSessionWizardTrigger = store.useTrigger;
